<template>
  <div class="page-box">
    <!-- 头部 -->
    <headerBar />
    <siteNav :selectedIndex="selectedIndex" />

    <!-- 内容区域 -->
    <div class="center-box">
      <div class="qualityControl-box">
        <div class="crumbs">首页 > “向错误学习”平台 > 发布</div>
        <div class="publish-box">
          <el-input type="textarea" placeholder="记录您此刻的心情/想法" class="text-box" v-model="textarea" maxlength="150" show-word-limit>
          </el-input>
          <div class="type-box" @click="onSelectType">
            #{{ showText() }}
          </div>
          <el-upload action="" :limit="9" :on-exceed="handleExceed" list-type="picture-card" :before-upload="customUpload" :file-list="fileList" :on-preview="handlePictureCardPreview" :on-remove="handleRemove">
            <i class="el-icon-camera"></i>
          </el-upload>
        </div>
        <div class="release-btn-box">
          <el-button class="bt" @click="onClickRelease">提交</el-button>
        </div>
      </div>
    </div>

    <el-dialog title="板块选择" :visible.sync="dialogVisibleTwo" width="30%" :before-close="handleClose">
      <div class="type-dialog-box">
        <div class="type-dialog-line">
          <div class="line-text">发布板块:</div>
          <el-select v-model="selectSector" placeholder="请选择">
            <el-option v-for="item in sectorList" :key="item.id" :label="item.sectionName" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button class="type-dialog-btn" type="primary" @click="onClickConfirm">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
    <!-- 页脚 -->
    <footer-bar />
  </div>
</template>

<script>
import FooterBar from "../../components/base/footerBar";
import headerBar from "@/components/base/headerBar";
import siteNav from "@/components/base/siteNav";
import { uploadFileCommunity, addForum, getSectionHeatList } from '@/api/forum'

export default {
  name: "index",
  components: { FooterBar, headerBar, siteNav },
  data() {
    return {
      textarea: '',
      fileList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      selectedIndex: null,
      sectorList: [],
      selectSector: "",
      dialogVisibleTwo: false,
      selectSectorTwo: "",
    };
  },
  methods: {
    // 取消选择板块弹窗
    handleClose() {
      this.dialogVisibleTwo = false
      this.selectSector = this.selectSectorTwo
    },
    // 确定选择板块弹窗
    onClickConfirm() {
      this.dialogVisibleTwo = false
      this.selectSectorTwo = this.selectSector
    },
    // 显示文本
    showText() {
      if(this.selectSectorTwo == "") {
        return '板块选择'
      }else {
        return this.sectorList.filter(item => item.id == this.selectSectorTwo)[0].sectionName
      }
    },
    // 选择板块类型
    onSelectType() {
      this.dialogVisibleTwo = true
    },
    // 删除图片
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    // 超出上传数量限制
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制上传 9 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    // 自定义上传函数
    async customUpload(file) {
      var formData = new FormData()
      formData.append('file', file)
      try {
        uploadFileCommunity(formData).then(res => {
          this.fileList.push(res.data[0])
        })
        onSuccess(res); // 成功回调
      } catch (err) {
        onError(err); // 错误回调
      }
    },
    // 获取所有板块
    getSectionHeatList() {
      getSectionHeatList({
        number: 1,
        limit: 100,
      }).then(res => {
        this.sectorList = res.data
      })
    },
    // 发布项目
    onClickRelease() {
      if(this.textarea == "") {
        this.$message({
          message: '请输入笔记内容',
          type: 'warning'
        });
        return
      }
      if(this.selectSectorTwo == "") {
        this.$message({
          message: '请选择关联板块',
          type: 'warning'
        });
        return
      }
      let data = {
        noteContent: this.textarea,
        noteImages: this.fileList,
        sectionId: this.selectSectorTwo,
      }
      addForum(data).then(res => {
        this.$message({
          message: '发布成功',
          type: 'success'
        });
        this.$router.go(-1)
      })
    },
    // 预览图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  },
  mounted() {
    this.getSectionHeatList()
  }
};
</script>

<style lang="less" scoped>
.publish-box {
  background: #fff;
  text-align: left;
  border-radius: 6px;
  margin-top: 25px;
  padding: 40px 35px 50px;

  .type-box {
    border: 1px solid #A3A3A3;
    border-radius: 100px;
    color: #A3A3A3;
    font-size: 12px;
    padding: 6px 14px;
    display: inline-block;
    margin: 20px 0;
    cursor: pointer;
  }

  /deep/.el-upload-list--picture-card .el-upload-list__item {
    width: 120px;
    height: 120px;
  }

  /deep/.el-upload--picture-card {
    width: 120px;
    height: 120px;
    line-height: 120px;
  }

  /deep/.el-textarea .el-input__count {
    bottom: -150px;
  }
}

.type-dialog-box {
  .type-dialog-line {
    display: flex;
    align-items: center;

    .line-text {
      margin-right: 20px;
    }
  }
}

.type-dialog-btn {
  background: linear-gradient(151.62deg, #EF4034 17.54%, #D82E35 117.32%);
  border: 1px solid #D82E35;
  border-color: #D82E35 !important;
}

.release-btn-box {
  display: flex;
  justify-content: center;
  padding-bottom: 100px;

  .bt {
    background: linear-gradient(151.62deg, #EF4034 17.54%, #D82E35 117.32%);
    color: #fff;
    font-size: 16px;
    height: 44px;
    border-radius: 6px;
    width: 255px;
    border: none;
    margin-top: 100px;
  }
}

.text-box {
  font-size: 14px;
  line-height: 22px;
  color: #000;

  /deep/.el-textarea__inner {
    border: none;
    resize: none;
    height: 280px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Publish/index.vue